import {CloudContract, Main} from 'app/components/entities/cloud/model';

function mapPairingStats(c: CloudContract.PairedStats): Main.PairedStats {
  return {
    lvs: c.livescrypt,
    devices: c.count,
    projects: c.vpearl,
  };
}

function mapCodeStatus(s: CloudContract.CodeStatus): Main.CodeStatus {
  switch (s) {
    case 'invalid_code':
      return 'invalid-code';
    case 'no_seats':
      return 'no-seats';
    case 'no_seats_expandable':
      return 'no-seats-expandable';
    default:
      return s;
  }
}

export const cloudMapper = {mapPairingStats, mapCodeStatus};
